import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { parse } from 'querystring';
import cookie from 'cookie';
import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { getUserExperimentVariationMap } from 'helpers/optimizely';
import { isEmpty } from 'helpers/verify';
var UTM_VARIABLES = ['source', 'medium', 'campaign', 'content', 'term'];
var COOKIE_NAME = 'cpUtmValues';
var THIRTY_DAYS_MS = 1e3 * 60 * 60 * 24 * 30;

var stripQuerystring = function stripQuerystring(location) {
  return location.replace(/\?.*$/, '');
};

var inviteUrl = function inviteUrl(location) {
  var isInviteUrl = /\/invite\/.*$/.test(location); // if this is an invite URL, this is our new value for `invite_url`, overwrite the old.

  if (isInviteUrl) {
    return stripQuerystring(location);
  } // if not, check if there's one in the cookie


  var cookies = cookie.parse(document.cookie);

  if (cookies && cookies[COOKIE_NAME]) {
    try {
      return JSON.parse(cookies[COOKIE_NAME]).invite_url;
    } catch (e) {
      /* noop */
    }
  }

  return null;
};

var parseUtmValues = function parseUtmValues() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.location.href;
  var queryParams = parse(location.split('?').slice(1).join('?'));
  var utmValues = {
    initial_url: stripQuerystring(location)
  };
  var inviteUrlOrNull = inviteUrl(location);

  if (inviteUrlOrNull) {
    utmValues.invite_url = inviteUrlOrNull;
  }

  UTM_VARIABLES.forEach(function (param) {
    if (queryParams["utm_".concat(param)]) {
      var value = queryParams["utm_".concat(param)];

      if (Array.isArray(value)) {
        value = value[value.length - 1];
      }

      utmValues[param] = value;
    }
  });
  return utmValues;
};

var getForApi = function getForApi() {
  var localStorageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var cookies = localStorageKey ? {} : cookie.parse(document.cookie);
  var localStorageValue = localStorageKey ? readLocalStorage(localStorageKey) : null;
  var cohortMap = getUserExperimentVariationMap();
  var hasCohortMap = !isEmpty(cohortMap);
  var hasUtmValue = localStorageKey ? !!localStorageValue : cookies && cookies[COOKIE_NAME];

  if (!hasUtmValue && !hasCohortMap) {
    return undefined;
  }

  var values = {};

  if (hasUtmValue) {
    var cpUtmValues = function () {
      try {
        return localStorageKey ? localStorageValue : JSON.parse(cookies[COOKIE_NAME]);
      } catch (err) {
        /* noop */
      }
    }();

    if (cpUtmValues) {
      values.initial_url = cpUtmValues.initial_url || '/';
      values.utm = UTM_VARIABLES.reduce(function (memo, param) {
        var value = cpUtmValues[param];
        return Object.assign(memo, _defineProperty({}, "utm_".concat(param), Array.isArray(value) ? value.pop() : value));
      }, {});

      if (cpUtmValues.invite_url) {
        values.invite_url = cpUtmValues.invite_url;
      }
    }
  }

  if (hasCohortMap) {
    values.cohort = JSON.stringify(cohortMap);
  }

  return Object.keys(values).length ? values : undefined;
};

var save = function save(location) {
  var localStorageKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var utmValues = parseUtmValues(location);
  var savedValue = localStorageKey ? readLocalStorage(localStorageKey) : cookie.parse(document.cookie)[COOKIE_NAME];

  if (!isEmpty(utmValues) || !savedValue) {
    if (localStorageKey) {
      writeLocalStorage(localStorageKey, utmValues);
    } else {
      document.cookie = cookie.serialize(COOKIE_NAME, JSON.stringify(utmValues), {
        expires: new Date(Date.now() + THIRTY_DAYS_MS),
        path: '/'
      });
    }
  }
};

export { getForApi };
export { parseUtmValues };
export { save };
export { COOKIE_NAME };